// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1D8H7","topBottomGutter":"Layout_topBottomGutter__2dQhP"};